import {
  FETCH_LOCATION_LINKS_LIST,
  FETCH_LOCATION_LINKS_LIST_ERROR,
  CLEAR_FETCH_LOCATION_LINKS_LIST,
  APPLY_LOCATION_LINK_DRAG,
  APPLY_LOCATION_LINK_DRAG_ERROR,
  CLEAR_LOCATION_LINK_DRAG,
  CREATE_LOCATION_LINK_SUCCESS,
  CREATE_LOCATION_LINK_ERROR,
  CLEAR_CREATE_LOCATION_LINK,
  PATCH_LOCATION_LINK_SUCCESS,
  PATCH_LOCATION_LINK_ERROR,
  CLEAR_PATCH_LOCATION_LINK,
  DELETE_LOCATION_LINK_SUCCESS,
  DELETE_LOCATION_LINK_ERROR,
  CLEAR_DELETE_LOCATION_LINK,
  CREATE_LOCATION_MARKER_SUCCESS,
  CREATE_LOCATION_MARKER_ERROR,
  CLEAR_CREATE_LOCATION_MARKER,
  PATCH_LOCATION_MARKER_SUCCESS,
  PATCH_LOCATION_MARKER_ERROR,
  CLEAR_PATCH_LOCATION_MARKER,
  DELETE_LOCATION_MARKER_SUCCESS,
  DELETE_LOCATION_MARKER_ERROR,
  CLEAR_DELETE_LOCATION_MARKER,
} from 'redux/location-links/types';

const initialState = {
  locationLinksList: null,
  locationLinksListError: null,
  locationLinkDrugSuccess: null,
  locationLinkDrugError: null,
  createLocationLinkSuccess: null,
  createLocationLinkError: null,
  patchLocationLinkSuccess: null,
  patchLocationLinkError: null,
  deleteLocationLinkSuccess: null,
  deleteLocationLinkError: null,
  createLocationMarkerSuccess: null,
  createLocationMarkerError: null,
  patchLocationMarkerSuccess: null,
  patchLocationMarkerError: null,
  deleteLocationMarkerSuccess: null,
  deleteLocationMarkerError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOCATION_LINKS_LIST:
      return {
        ...state,
        locationLinksList: action.payload.data,
        locationLinksListError: null,
      };
    case FETCH_LOCATION_LINKS_LIST_ERROR:
      return {
        ...state,
        locationLinksList: null,
        locationLinksListError: action.payload.data,
      };
    case CLEAR_FETCH_LOCATION_LINKS_LIST:
      return {
        ...state,
        locationLinksList: null,
        locationLinksListError: null,
      };
    case APPLY_LOCATION_LINK_DRAG:
      return {
        ...state,
        locationLinkDrugSuccess: action.payload.data,
        locationLinkDrugError: null,
      };
    case APPLY_LOCATION_LINK_DRAG_ERROR:
      return {
        ...state,
        locationLinkDrugSuccess: null,
        locationLinkDrugError: action.payload.data,
      };
    case CLEAR_LOCATION_LINK_DRAG:
      return {
        ...state,
        locationLinkDrugSuccess: null,
        locationLinkDrugError: null,
      };
    case CREATE_LOCATION_LINK_SUCCESS:
      return {
        ...state,
        createLocationLinkSuccess: action.payload.data,
        createLocationLinkError: null,
      };
    case CREATE_LOCATION_LINK_ERROR:
      return {
        ...state,
        createLocationLinkSuccess: null,
        createLocationLinkError: action.payload.data,
      };
    case CLEAR_CREATE_LOCATION_LINK:
      return {
        ...state,
        createLocationLinkSuccess: null,
        createLocationLinkError: null,
      };
    case PATCH_LOCATION_LINK_SUCCESS:
      return {
        ...state,
        patchLocationLinkSuccess: action.payload.data,
        patchLocationLinkError: null,
      };
    case PATCH_LOCATION_LINK_ERROR:
      return {
        ...state,
        patchLocationLinkSuccess: null,
        patchLocationLinkError: action.payload.data,
      };
    case CLEAR_PATCH_LOCATION_LINK:
      return {
        ...state,
        patchLocationLinkSuccess: null,
        patchLocationLinkError: null,
      };
    case DELETE_LOCATION_LINK_SUCCESS:
      return {
        ...state,
        deleteLocationLinkSuccess: action.payload.data,
        deleteLocationLinkError: null,
      };
    case DELETE_LOCATION_LINK_ERROR:
      return {
        ...state,
        deleteLocationLinkSuccess: null,
        deleteLocationLinkError: action.payload.data,
      };
    case CLEAR_DELETE_LOCATION_LINK:
      return {
        ...state,
        deleteLocationLinkSuccess: null,
        deleteLocationLinkError: null,
      };
    case CREATE_LOCATION_MARKER_SUCCESS:
      return {
        ...state,
        createLocationMarkerSuccess: action.payload.data,
        createLocationMarkerError: null,
      };
    case CREATE_LOCATION_MARKER_ERROR:
      return {
        ...state,
        createLocationMarkerSuccess: null,
        createLocationMarkerError: action.payload.data,
      };
    case CLEAR_CREATE_LOCATION_MARKER:
      return {
        ...state,
        createLocationMarkerSuccess: null,
        createLocationMarkerError: null,
      };
    case PATCH_LOCATION_MARKER_SUCCESS:
      return {
        ...state,
        patchLocationMarkerSuccess: action.payload.data,
        patchLocationMarkerError: null,
      };
    case PATCH_LOCATION_MARKER_ERROR:
      return {
        ...state,
        patchLocationMarkerSuccess: null,
        patchLocationMarkerError: action.payload.data,
      };
    case CLEAR_PATCH_LOCATION_MARKER:
      return {
        ...state,
        patchLocationMarkerSuccess: null,
        patchLocationMarkerError: null,
      };
    case DELETE_LOCATION_MARKER_SUCCESS:
      return {
        ...state,
        deleteLocationMarkerSuccess: action.payload.data,
        deleteLocationMarkerError: null,
      };
    case DELETE_LOCATION_MARKER_ERROR:
      return {
        ...state,
        deleteLocationMarkerSuccess: null,
        deleteLocationMarkerError: action.payload.data,
      };
    case CLEAR_DELETE_LOCATION_MARKER:
      return {
        ...state,
        deleteLocationMarkerSuccess: null,
        deleteLocationMarkerError: null,
      };
    default:
      return state;
  }
};
